import { Fragment, useEffect } from "react";
import countries from "../../lib/countries.json";
import { useSelector, useDispatch } from "react-redux";
import * as React from "react";
import { ProgressBar } from "@progress/kendo-react-progressbars";
import { Input } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import {
  createPendingSubscription,
  setFormValue,
  setPageValue,
} from "../../redux/slices/onboardingpageslice";
import { addNotification } from "../../redux/slices/notificationsslice";
import { notificationDurationMiddle } from "../../lib/utils";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const OnBoardingPageForm = (props) => {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.onBoardingPage);
  const { t } = useTranslation();
  const appearance = useSelector((state) => state.appearance); 
  const steps = [
    { label: t("onboarding.name") },
    { label: t("onboarding.companyjob")},
    { label: t("onboarding.accountinfo")},
    { label: t("onboarding.mobile")},
  ];

  const progress = (pageState.step / (steps.length - 1)) * 100;

  // Handle is dirty
  const updateDirtyState = props.updateDirtyState;

  const businessTypes = [
    t("onboarding.businessTypes1"),
    t("onboarding.businessTypes2"),
    t("onboarding.businessTypes3"),
    t("onboarding.businessTypes4"),
    t("onboarding.businessTypes5"),
    t("onboarding.businessTypes6"),
    t("onboarding.businessTypes7"),
    t("onboarding.businessTypes8"),
    t("onboarding.businessTypes9"),
    t("onboarding.businessTypes10"),
    t("onboarding.businessTypes11"),
    t("onboarding.businessTypes12"),
    t("onboarding.businessTypes13"),
    t("onboarding.businessTypes14"),
    t("onboarding.businessTypes15"),
    t("onboarding.businessTypes16"),
    t("onboarding.businessTypes17"),
    t("onboarding.businessTypes18"),
    t("onboarding.businessTypes19"),
    t("onboarding.businessTypes20"),
    t("onboarding.businessTypes21"),
    t("onboarding.businessTypes22"),
    t("onboarding.businessTypes23"),
    t("onboarding.businessTypes24"),
    t("onboarding.businessTypes25"),
    t("onboarding.businessTypes26"),
    t("onboarding.businessTypes27"),
    t("onboarding.businessTypes28"),
    t("onboarding.businessTypes29"),
    t("onboarding.businessTypes30"),
    t("onboarding.businessTypes31"),
    t("onboarding.businessTypes32"),
    t("onboarding.businessTypes33"),
    t("onboarding.businessTypes34"),
    t("onboarding.businessTypes35"),
    t("onboarding.businessTypes36")
  ];

  useEffect(() => {
    updateDirtyState();
  }, [pageState.formInitialValues, pageState.formValues]);

  const [errors, setErrors] = React.useState({});

  const handleInputChange = (e) => {
    dispatch(setFormValue({ id: e.target.name, value: e.target.value }));
  };

  const handleDropdownChange = (e) => {
    dispatch(setFormValue({ id: "businessType", value: e.target.value }));
  };

  // Email validation helper function
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateStep = () => {
    const newErrors = {};

    if (pageState.step === 0 && !pageState.formValues.name.trim()) {
      newErrors.name = t("onboarding.name_error");
      dispatch(
        addNotification({
          text: newErrors.name,
          type: "error",
          closable: true,
          duration: notificationDurationMiddle,
          position: "topRight",
        })
      );
    }

    if (pageState.step === 1) {
      if (!pageState.formValues.company.trim()) {
        newErrors.company = t("onboarding.company_error");
        dispatch(
          addNotification({
            text: newErrors.company,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
      }
      if (!pageState.formValues.businessType) {
        newErrors.businessType = t("onboarding.business_error");
        dispatch(
          addNotification({
            text: newErrors.businessType,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
      }
    }

    if (pageState.step === 2) {
      if (!pageState.formValues.username.trim()) {
        newErrors.username = t("onboarding.username_error");
        dispatch(
          addNotification({
            text: newErrors.username,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
      }
      if (!pageState.formValues.email.trim()) {
        newErrors.email = t("onboarding.email_error");
        dispatch(
          addNotification({
            text: newErrors.email,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
      } else if (!isValidEmail(pageState.formValues.email)) {
        newErrors.email = t("onboarding.email_invalid");
        dispatch(
          addNotification({
            text: newErrors.email,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
      }
      if (
        pageState.subscriptions.find(
          (e) => e.Username === pageState.formValues.username
        )
      ) {
        newErrors.username = t("onboarding.username_exist");
        dispatch(
          addNotification({
            text: newErrors.username,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
      }
      if (
        pageState.subscriptions.find(
          (e) => e.Email === pageState.formValues.email
        )
      ) {
        newErrors.email = t("onboarding.email_exist");
        dispatch(
          addNotification({
            text: newErrors.email,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
      }
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStep()) {
      dispatch(setPageValue({ id: "step", value: Number(pageState.step + 1) }));
    }
  };

  const handlePrevious = () => {
    dispatch(setPageValue({ id: "step", value: Number(pageState.step - 1) }));
  };

  const handleSubmit = () => {
    if (validateStep()) {
      console.log("Submitted values:", pageState.formValues);
      let phoneNumber =
        pageState.formValues.countryCode.dial_code + pageState.formValues.mobile;
      dispatch(
        createPendingSubscription(
          pageState.formValues.name,
          pageState.formValues.company,
          pageState.formValues.businessType,
          pageState.formValues.username,
          pageState.formValues.email,
          phoneNumber,
          props.plan,
          t
        )
      );
      //window.open(`https://buy.stripe.com/${props.plan}`, "_blank");
    }
  };

  const handleCountryCodeChange = (e) => {
    dispatch(setFormValue({ id: "countryCode", value: e.target.value }));
  };

  const renderStepContent = () => {
    switch (pageState.step) {
      case 0:
        return (
          <Fragment>
            <label>{t("onboarding.call")}</label>
            <Input
              name="name"
              value={pageState.formValues.name}
              onChange={handleInputChange}
              validationMessage={errors.name}
              required
              valid={!errors.name}
              style={{ width: "100%" }}
            />
          </Fragment>
        );
      case 1:
        return (
          <Fragment>
            <label>{t("onboarding.company")}</label>
            <Input
              name="company"
              value={pageState.formValues.company}
              onChange={handleInputChange}
              validationMessage={errors.company}
              required
              valid={!errors.company}
              style={{ width: "100%" }}
            />
            <label>{t("onboarding.business")}</label>
            <DropDownList
              data={businessTypes}
              value={pageState.formValues.businessType}
              onChange={handleDropdownChange}
              required
              validationMessage={errors.businessType}
              style={{ width: "100%"}}
            />
          </Fragment>
        );
      case 2:
        return (
          <Fragment>
            <label>{t("onboarding.username")}</label>
            <Input
              name="username"
              value={pageState.formValues.username}
              onChange={handleInputChange}
              validationMessage={errors.username}
              required
              valid={!errors.username}
              style={{ width: "100%" }}
            />
            <label>{t("onboarding.email")}</label>
            <Input
              name="email"
              type="email"
              value={pageState.formValues.email}
              onChange={handleInputChange}
              validationMessage={errors.email}
              required
              valid={!errors.email}
              style={{ width: "100%" }}
            />
          </Fragment>
        );
      case 3:
        return (
          <Fragment>
            <label>{t("onboarding.mobile")}</label>
            <div className="mobile-input-group">
              {countries.length > 0 && (
                <DropDownList
                  data={countries}
                  textField="name"
                  dataItemKey="code" // use "code" or whatever uniquely identifies a country
                  value={pageState.formValues.countryCode}
                  onChange={handleCountryCodeChange}
                  style={{ width: "40%", textAlign: "center" }}
                  itemRender={(li, itemProps) => (
                    <li {...li.props}>
                      <img
                        src={`https://flagcdn.com/24x18/${itemProps.dataItem.code.toLowerCase()}.png`}
                        alt={itemProps.dataItem.name}
                        style={{ width: "20px", marginRight: "10px" }}
                      />
                      {itemProps.dataItem.name} ({itemProps.dataItem.dial_code})
                    </li>
                  )}
                  valueRender={(element, valueProps) => {
                    const item = pageState.formValues.countryCode;
                    //debugger;
                    if (!item) return <span>{t("onboarding.country")}</span>;

                    return (
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={`https://flagcdn.com/24x18/${item.code.toLowerCase()}.png`}
                          alt={item.name}
                          style={{ width: "20px", marginRight: "10px" }}
                        />
                        {item.dial_code}
                      </span>
                    );
                  }}
                />
              )}

              <Input
                name="mobile"
                value={pageState.formValues.mobile}
                onChange={handleInputChange}
                style={{ width: "60%" }}
              />
            </div>
          </Fragment>
        );

      default:
        return null;
    }
  };

  return (
    <div
      className="onboarding-form"
      style={{ width: "100%", margin: "0 auto" }}
    >
      <div style={{ marginTop: "20px" }}>
        {/* Smooth Progress Bar */}
        <ProgressBar
          value={progress}
          style={{
            height: 8,
            borderRadius: 10,
            transition: "width 0.5s ease-out",
            backgroundColor: "#e0e0e0",
          }}
        />
      </div>

      <div
        className="onboarding-content"
        style={{
          width: "600px",
          margin: "0 auto",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            marginTop: "30px",
            minHeight: "200px",
            position: "relative",
          }}
        >
          <div key={pageState.step} className="step-content fade-slide">
            {renderStepContent()}
          </div>
        </div>

        <div
          className="button-group"
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            onClick={handlePrevious}
            disabled={pageState.step === 0}
            themeColor="secondary"
          >
            {t("onboarding.previous")}
          </Button>

          {pageState.step < steps.length - 1 ? (
            <Button onClick={handleNext} themeColor="primary">
              {t("onboarding.next")}
            </Button>
          ) : (
            <Button onClick={handleSubmit} themeColor="primary">
              {t("onboarding.submit")}
            </Button>
          )}
        </div>
      </div>
      {/* Custom Styling */}
      <style>
        {`
          .onboarding-form {
            // font-family: 'Arial', sans-serif;
            // background-color: #f9f9f9;
            padding: 20px;
            // border-radius: 10px;
            // box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
            direction:${appearance.isRightToLeft ? "rtl" : "ltr"}
          }

          .button-group button {
            min-width: 120px;
            font-size: 14px;
            border-radius:0;
          }

          .button-group button:disabled {
            background-color: #e0e0e0;
            color: #888;
          }

          /* Full Width Inputs */
          .onboarding-form input {
            width: 100%;
            margin-bottom: 15px;
          }

          .onboarding-form .k-dropdown {
            width: 100%;
            margin-bottom: 15px;
            direction:${appearance.isRightToLeft ? "rtl" : "ltr"}
          }

          /* Making the Progress Bar Number Transparent */
          .k-progress-bar-text, .k-progress-status {
            visibility: hidden;
          }

          /* Moving Labels Above Inputs */
          .onboarding-form label {
            font-size:25px;
            display: block;
            margin-bottom: 15px;
            font-weight: bold;
          }
          .onboarding-form input, .onboarding-form input:focus  {
            font-size:20px;border-radius:0;
            display: block;height:50px; border:0;border-bottom:3px solid #ccc;
          }

          .onboarding-form .k-dropdownlist, .onboarding-form .k-dropdownlist:focus  {
            font-size:20px;border-radius:0;
            height:50px; border:0;border-bottom:3px solid #ccc;
          }

          /* Animation class */
        .fade-slide {
            animation: fadeSlideIn 0.4s ease-in-out;
        }

        @keyframes fadeSlideIn {
            0% {
                opacity: 0;
                transform: translateX(30px);
            }
            100% {
                opacity: 1;
                transform: translateX(0);
            }
        }
        .mobile-input-group {
            display: flex;
            gap: 10px;
            margin-bottom: 15px;
        }

        .mobile-input-group .k-input,
        .mobile-input-group .k-dropdown {
            margin-bottom: 0 !important;
        }

        .mobile-input-group .k-dropdownlist {
            margin-bottom: 0 !important;
            display:flex;
            justify-content:space-around;
              font-size:20px;border-radius:0;
             height:50px; border:0;border-bottom:3px solid #ccc;
        }

        @media (max-width: 767px) {
          .onboarding-form {
            padding: 30px;
          }

          .onboarding-form .onboarding-content {
            width: 100% !important;
            max-width: 100%;
          }

          .onboarding-form label {
            font-size: 20px;
          }

          .onboarding-form input,
          .onboarding-form input:focus,
          .onboarding-form .k-dropdownlist,
          .onboarding-form .k-dropdownlist:focus,
          .mobile-input-group .k-dropdownlist {
            font-size: 16px;
            height: 46px;
          }

          .onboarding-form .button-group {
            flex-direction: column-reverse;
            gap: 12px;
          }

          .onboarding-form .button-group button {
            width: 100%;
          }
        }
        `}
      </style>
    </div>
  );
};
